
import React, { useEffect, useState } from 'react';
import './RegistroDeNaoConformidade.css';
import Conexao from '../../Config/conexao';
import axios from 'axios';
import emailjs from '@emailjs/browser';
import Button from 'react-bootstrap/Button';
import { Container, ContainerForm, TextFieldStyled } from "./styles";
import { Navbar, Row, Col, Offcanvas } from 'react-bootstrap';
import { Link } from 'react-router-dom';
function RegistroDenaoconformidade() {

  const [showInput, setShowInput] = useState(false);

  const [origem, setOrigem] = useState();
  const [cliente, setCliente] = useState();
  const [setorIdentificou, setSetorIdentificou] = useState();
  const [setorOrigem, setSetorOrigem] = useState();
  const [descrever, setDescrever] = useState();
  const [documentoDoCliente, setDocumentoDoCliente] = useState();
  const [responsavel1, setResponsavel1] = useState();
  const [responsavel2, setResponsavel2] = useState();
  const [reincidente, setReincidente] = useState();
  const [descricaoproblema, setDescricaoproblema] = useState();
  const [evidencia1, setEvidencia1] = useState();
  const [evidencia2, setEvidencia2] = useState();
  const [pegaProtocolo, setPegaProtocolo] = useState();
  const [origemSetor, setOrigemSetor] = useState();
  const [showSidebar, setShowSidebar] = useState(false);
  const [dataAtual, setDataAtual] = useState();
  const [liClicked, setLiClicked] = useState(false);

  const [setorLogado, setSetorLogado] = useState();
  const [setorDoCargo, setSetorDoCargo] = useState();
  const handleCloseSidebar = () => {
    setShowSidebar(false);

}

  function carregaUser() { 
    
    setSetorLogado(localStorage.usuario)
    setResponsavel1(localStorage.usuario);
    console.log(localStorage);
    

   };
  useEffect(() => { console.log("entrada registrada");  carregaUser() });

  // async function getSetor() {
  //   const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
  //   console.log(res.data);
  //   if (res.data.success === false) {
  //     //  setLoading(false)
  //     //  falha();  
  //   } else {
  //     setSetorDoCargo(res.data.setor);
  //     // console.log( "SEETOOOOOR  " + setorDoCargo);
  //     console.log(res.data.setor);
  //     setSetorIdentificou(res.data.setor)
  //     console.log("QUEEEEM  " + setorLogado);
  //   }
  // };
  async function getSetor() {
    const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
    console.log(res);
    if (res.data.success === true) {
      setSetorDoCargo(res.data.setor);
      // console.log( "SEETOOOOOR  " + setorDoCargo);
      console.log(res.data.setor);
      setSetorIdentificou(res.data.setor)
      console.log("QUEEEEM  " + setorLogado);
    }

    
  };

  useEffect(() => { getSetor() }, []);

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    //setBackgroundImage(images[index]);

}
 


  /*  function Confirmacao() {
     alert('Solicitação aberta com Sucesso!')
     
   }; 
  */

  //BANCO DE DADOS

  /*   async function add() {
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('pt-BR');
      const obj = { origem, cliente, setorIdentificou, setorOrigem, descrever, documentoDoCliente, responsavel1, responsavel2, reincidente, descricaoproblema, evidencia1, evidencia2, origemSetor, dataAtual: formattedDate, imagem: imagemPreview };
     
      const res = await axios.post(Conexao.api+ 'InsertRegistroDeNaoConformidadeWEB.php', obj);
      if (res.data.success === true) {
      SelecioneOEmail();
      }
      Limpar() 
     
    }; */


  async function add() {
    // Array para armazenar os nomes dos campos vazios
    const camposVazios = [];

    // Verificar se todos os campos obrigatórios estão preenchidos
    if (!origem) camposVazios.push("Origem");
    if (origem !== 'Outros') { if (!cliente) camposVazios.push("Cliente"); }
    if (!setorIdentificou) camposVazios.push("Setor Identificou");
    if (!setorOrigem) camposVazios.push("Setor Origem");


    if (!reincidente) camposVazios.push("Reincidente");
    if (!descricaoproblema) camposVazios.push("Descrição da não conformidade");
    if (!evidencia1) camposVazios.push("Evidência 1");


    if (camposVazios.length > 0) {
      const camposNaoPreenchidos = camposVazios.join(", ");
      alert(`Por favor, preencha os seguintes campos obrigatórios: ${camposNaoPreenchidos}`);
      return;
    }

    const substatu = 'Aberto';

    const obj = {
      origem, cliente, setorIdentificou, setorOrigem, descrever, documentoDoCliente, responsavel1, responsavel2,
      reincidente, descricaoproblema, evidencia1, evidencia2, origemSetor, dataAtual, imagem: imagemPreview, substatu,
    };

    try {
      const res = await axios.post(Conexao.api + 'InsertRegistroDeNaoConformidadeWEB.php', obj);
      //  const res = await axios.post(  + 'InsertAberturaOSManutencao.php', obj);
      if (res.data.success === true) {
        setBlockX(true)
        //   SelecioneOEmail();

        EnviarEmail();

        const res2 = await axios.get(Conexao.api + 'BuscarProtocoloRNCWEB.php');

        alert('Registro de NC realizado com sucesso!   RNC: ' + res2.data.pegaProtocolo)

      }

    } catch (error) {
      // Tratar erros caso ocorram durante a requisição
      console.error('Erro ao tentar adicionar:', error);
    }
    Limpar()
  };

  const [blockX, setBlockX] = useState(false)

  //Enviar E-mail
  /*   async function getItemQSSMA() {  
      const res = await axios.get(Conexao.api + 'BuscarProtocoloRNCWEB.php' ); 
       
       setPegaProtocolo(res.data.pegaProtocolo);
  
      console.log("TESTE DE PROTOCOLO "+ res.data.pegaProtocolo)
    
      if (res.data.success === false) { 
      } else {
  
     const TemplateParam = {
       mensage: res.data.pegaProtocolo
     }
     emailjs.send("service_x40cz13", "template_g1qkzlr", TemplateParam, "8wUT7xbpjnJI-SAuM")
     .then((response)=>{console.log("e-mail enviado", response.status, response.text)}, (erro)=>{console.log("erro:" , erro)})  
    // alert("e-mail enviado")
    console.log("EMAIL ENVIADO  ..." )
  
  
  
    alert('Registro de NC realizado com sucesso!   RNC: ' + res.data.pegaProtocolo)
  
      }   
    };
  
  
    async function getItemRH() {  
      const res = await axios.get(Conexao.api + 'BuscarProtocoloRNCWEB.php' ); 
       
       setPegaProtocolo(res.data.pegaProtocolo);
  
      console.log("TESTE DE PROTOCOLO "+ res.data.pegaProtocolo)
    
      if (res.data.success === false) { 
      } else {
  
        const TemplateParam = {
          mensage: pegaProtocolo
        }
        emailjs.send("service_x40cz13", "template_s45zlua", TemplateParam, "8wUT7xbpjnJI-SAuM")
        .then((response)=>{console.log("e-mail enviado", response.status, response.text)}, (erro)=>{console.log("erro:" , erro)})  
    console.log("EMAIL ENVIADO  ..." )
  
  
  
    alert('Registro de NC realizado com sucesso!    RNC: ' + res.data.pegaProtocolo)
  
      }   
    }; */

  const [nomeResponsavel, setNomeResponsavel] = useState([]);


  async function getResponsavel() {
    const res = await axios.get(Conexao.api + 'ListaCadastroDeResponsaveisWEB.php?responsavel2=' + setorOrigem);

    /* console.log("TESTE DE PROTOCOLO "+ res.data.pegaProtocolo) */

    if (res.data.success === false) {
    } else {
      setNomeResponsavel(res.data.result);
    }
  };


  useEffect(() => { getResponsavel() });

  const [nomeResponsavel2, setNomeResponsavel2] = useState([]);


  async function getResponsavel2() {
    const res = await axios.get(Conexao.api + 'ListaCadastroDeResponsaveisWEB.php?responsavel2=' + setorIdentificou);

    /* console.log("TESTE DE PROTOCOLO "+ res.data.pegaProtocolo) */
    if (res.data.success === false) {
    } else {
      // LimpaResponsavel(); 
      setNomeResponsavel2(res.data.result);

    }
  };

  useEffect(() => {
    getResponsavel2();
  }, [setorIdentificou]);







  /*   function SelecioneOEmail(e){ 
      if( setorOrigem === 'QSSMA'){getItemQSSMA(e)}
      else if(setorOrigem === 'RH'){getItemRH(e)}
      else if(setorOrigem === 'Geotecnia'){getItemRH()}
      else if(setorOrigem === 'Comercial'){getItemRH()}
      else if(setorOrigem === 'Laboratório'){getItemRH()}
      else if(setorOrigem === 'Manutençao'){getItemRH()}
      else if(setorOrigem === 'Pesquisa e Mineral'){getItemRH()}
      else if(setorOrigem === 'Compras'){getItemRH()}
      else {alert('Setor de origem não selecionado ' )}
   
     }; */


  const handleSelectChange = (e) => {
    if (e.target.value === 'Outros') {
      setShowInput(true);
      console.log('selecionado')

    } else {
      setShowInput(false);
      console.log('não selecionado')
    }
  };

  function Limpar() {

    setOrigem('');
    setCliente('');
    setSetorIdentificou('');
    setSetorOrigem('');
    setDescrever('');
    setDocumentoDoCliente('');
    setResponsavel1('');
    setResponsavel2('');
    setReincidente('');
    setDescricaoproblema('');
    setEvidencia1('');
    setEvidencia2('');
    setOrigemSetor('');
    setImagem('');
    setImagemPreview('');
    setDataAtual('');

    setBlockX(false);

  };






  const [imagem, setImagem] = useState();
  const [imagemPreview, setImagemPreview] = useState();


  const handleDescricaoChange = (e) => {
    setDescricaoproblema(e.target.value);
  };

  const handleImagemChange = (e) => {
    const file = e.target.files[0];
    setImagem(file);
    // Criando uma URL temporária para exibir a prévia da imagem selecionada
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagemPreview(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleDownloadClick = () => {
    // Verifica se a imagem está disponível para download
    if (imagemPreview) {
      const link = document.createElement('a');
      link.href = imagemPreview;
      link.download = "imagem_selecionada.jpg"; // O nome que você quer dar ao arquivo baixado
      link.click();
    } else {
      console.log("Nenhuma imagem selecionada para download.");
    }
  };


  //  Email


  const [email, setEmail] = useState();
  const [nprocesso, setNprocesso] = useState();

  async function EnviarEmail() {

    const setorX = ('SGI');

    const res2 = await axios.get(Conexao.api + 'BuscarProtocoloRNCWEB.php');
    setNprocesso(res2.data.pegaProtocolo);

    const res3 = await axios.get(Conexao.api + 'BuscarResponsaveisEmailWEB.php? responsavel2=' + responsavel2);
    setEmail(res3.data.Email);

    console.log('email destino  ' + res3.data.Email)

    const res = await axios.get('http://servidor.geocontrole.com/EmailSGI/EmailAberturaNC.php? email=' + res3.data.Email + '&nprocesso=' + res2.data.pegaProtocolo
      + '&setorOrigem2=' + setorX + '&descricao=' + descricaoproblema);

    if (res.data.success === false) { }
    else { }
  };







  return <div className="home">

    <div className="banner" style={{ backgroundColor: '#DEDACF', width: 'auto', height: 'auto', minHeight: '1600px', minWidth: '1600px' }} >


      <div className="sidebar-button">
        <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
          <div className="icon-container">
            <i className="bi bi-list icon-circle"></i>
          </div>
        </Button>

      </div>
      {/* Bandeiras */}
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Titulo */}
      <div className="sidebar-Text">
        <text style={{ color: '#187A40', fontWeight: 'bold', textShadow: 'none', fontFamily: 'Open Sans, sans-serif', marginLeft: '20%', }}>Registro de Não Conformidade</text>
      </div>
      {/* Logica da pagina */}

      <Container>
        <ContainerForm>
          



            <body class="container text-center  ">
              <div class="col  align-items-center justify-content-center p-1 ">
                <div class="row d-flex align-items-center justify-content-center ">

                  <div class="col-2">
                    <h6>Origem</h6>
                    <select name='Origem' id='Origem' className=' form-select  borda align-items-center text-start colorInput ' onChange={(e) => setOrigem(e.target.value)} onClick={handleSelectChange} value={origem} >
                      <option selected value="...">Selecione...</option>
                      <option value="Auditoria Interna">Auditoria Interna</option>
                      <option value="Auditoria Externa">Auditoria Externa</option>
                      <option value="Auditoria de clientes">Auditoria de clientes</option>
                      <option value="Oportunidade de melhoria">Oportunidade de melhoria</option>
                      <option value="Reclamação do cliente">Reclamação do cliente</option>
                      <option value="Processos Internos">Processos Internos</option>
                      <option value="Outros">Outros</option>
                    </select>
                  </div>

                  {origem !== 'Outros' ?
                    <div class="col-2 ">
                      <h6>Cliente</h6>
                      <input className='form-control  borda text-center colorInput ' onChange={(e) => setCliente(e.target.value)} value={cliente}></input>
                    </div>
                    : null}



                  <div class="col-3">
                    <h6>Setor que identificou </h6>
                    <input name='Origem' id='Origem' className=' form-select  borda align-items-center text-start colorInput ' onChange={(e) => setSetorIdentificou(e.target.value)} value={setorIdentificou} >
                      {/* <option selected value="...">Selecione...</option>
                      <option value="QSSMA">QSSMA</option>
                      <option value="SGI">SGI</option>
                      <option value="RH">RH</option>
                      <option value="Geotecnia">Geotecnia</option>
                      <option value="Comercial">Comercial</option>
                      <option value="Laboratório">Laboratório</option>
                      <option value="Manutençao">Manutenção</option>
                      <option value="Pesquisa e Mineral">Pesquisa Mineral</option>
                      <option value="Compras">Compras</option>
                      <option value="Suporte TI">Suporte TI</option>
                      <option value="Diretoria">Diretoria</option>
                       <option value="Teste">TESTE</option>  */}

                    </input>
                  </div>

                  <div class="col-3">
                    <h6 >Setor de origem </h6>
                    <select name='Origem' id='Origem' className=' form-select  borda align-items-center text-start colorInput ' onChange={(e) => setSetorOrigem(e.target.value)} value={setorOrigem} >
                      <option selected value="...">Selecione...</option>
                      <option value="QSSMA">QSSMA</option>
                      <option value="SGI">SGI</option>
                      <option value="RH">RH</option>
                      <option value="Geotecnia">Geotecnia</option>
                      <option value="Comercial">Comercial</option>
                      <option value="Laboratório">Laboratório</option>
                      <option value="Manutençao">Manutenção</option>
                      <option value="Pesquisa e Mineral">Pesquisa Mineral</option>
                      <option value="Compras">Compras</option>
                      <option value="Suporte TI">Suporte TI</option>
                      <option value="Diretoria">Diretoria</option>
                      {/*  <option value="Teste">TESTE</option> */}

                    </select>
                  </div>

                  <div class="col-2">
                    <h6>Data abertura</h6>
                    <input type='date' className=' form-control  borda align-items-center text-start colorInput ' onChange={(e) => setDataAtual(e.target.value)} value={dataAtual} >

                    </input>
                  </div>

                </div>
              </div>
            </body>



            {showInput === true ?
              <div class="row d-flex  text-center align-items-center  ">
                <div class="col-6 ms-auto">
                  <h6>Descrição</h6>
                  <textarea cols={30} rows={3} className='form-control  borda colorInput  resize ' onChange={(e) => setDescrever(e.target.value)} value={descrever} ></textarea>
                </div>
              </div>
              : null}


            <br />
            <body class="container text-center  ">
              <div class="col  align-items-center justify-content-center p-1 ">
                <div class="row d-flex align-items-center justify-content-center ">


                  <div class="col-2 ">
                    <h6>É Reincidente?
                    </h6>
                    <select className=' form-select  borda align-items-center text-start colorInput ' onChange={(e) => setReincidente(e.target.value)} value={reincidente} >
                      <option selected value="...">Selecione...</option>
                      <option value="Sim">Sim</option>
                      <option value="Não">Não</option>
                    </select>
                  </div>

                  <div class="col-2 ">
                    <h6>Doc. do Cliente</h6>
                    <input className='form-control  borda text-center colorInput ' onChange={(e) => setDocumentoDoCliente(e.target.value)} value={documentoDoCliente}></input>
                  </div>

                  <div class="col-3">
                    <h6>Responsável pela identificação</h6>
                    <input className='form-control  borda text-left colorInput' onChange={(e) => setResponsavel1(e.target.value)} value={responsavel1}>
          
                    </input>
                  </div>

                  <div class="col-3">
                    <h6>Responsável pelo setor origem</h6>
                    <select className=' form-select  borda align-items-center text-start colorInput ' onChange={(e) => setResponsavel2(e.target.value)} value={responsavel2} >
                      <option selected value="...">Selecione...</option>

                      {nomeResponsavel.map((equipamento) => (<option key={equipamento.id} > {equipamento.nome} </option>))}

                    </select>
                  </div>


                  <div class="col-2">

                  </div>




                </div>
              </div>
            </body>

            <body class="container text-center p-2 mt-4 ">


              <h6>Descrição detalhada da não conformidade </h6>
              <textarea cols={77} rows={4} className='form-control  borda colorInput  resize ' onChange={(e) => setDescricaoproblema(e.target.value)} value={descricaoproblema} ></textarea>



              <br />

              <h6 className='mt-4'>Evidências </h6>
              <textarea cols={77} rows={4} className='form-control  borda colorInput  resize ' onChange={(e) => setEvidencia1(e.target.value)} value={evidencia1} ></textarea>
              <input className='mt-3' type="file" onChange={handleImagemChange} />

              {/* Exibição da prévia da imagem */}
              {imagemPreview && (
                <div>
                  <img src={imagemPreview} alt="Prévia da imagem" style={{ maxWidth: '100px' }} />
                </div>
              )}

              {/* Botão de download */}
              {imagem && (
                <div>
                  <button class="btn btn-outline-success mb-3" onClick={handleDownloadClick}>Download</button>
                </div>
              )}
              <br />

            </body>

            <div class="row d-flex align-items-end justify-content-end ">
              <div class="col-4">
                <button hidden={blockX} disabled={blockX}  class="btnlogin " >Salvar</button>
                {/* <button  onClick={(e) =>  EnviarEmail(e)  }  class="btnlogin " >Enviar</button>  */}
              </div>
            </div>


            <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
                    <div className="offcanvas-header">


                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
                    </div>
                    <Offcanvas.Body>
                        <ul>
                            <li className={`${liClicked ? 'li-slide-right' : ''}`} >
                                <Link to="/app/SGI" style={{ textDecoration: 'none' }}>
                                    <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Menu</button></Link>
                            </li>

                        </ul>
                    </Offcanvas.Body>
                </Offcanvas>

    

        </ContainerForm>
      </Container>

    </div>
  </div>
}

export default RegistroDenaoconformidade;